import * as pinia from 'pinia';
import { useDevicesList } from '@vueuse/core';
import { DEVICES_KINDS, DEVICE_SLOT_ACTIONS } from '@/Utils/vice-constants';

const useDeviceAndSessionSetupStore = pinia.defineStore('DeviceAndSessionSetupStore', {
  state: () => ({
    deviceTypesUseCases: [],
    connectedDevices: useDevicesList({
      requestPermissions: true,
    }),
    clinicianDefaultDevices: [],
  }),

  getters: {
    getDeviceTypesUseCases: (state) => state.deviceTypesUseCases,

    // get connected device for slot according to slot kind
    getConnectedDevices:
      (state) =>
      (deviceKind = null) => {
        // get rid of the 'default' and 'communications' devices
        const devicesWithoutDoubles = state.connectedDevices.devices.filter(
          (device) => device.deviceId !== 'default' && device.deviceId !== 'communications',
        );

        if (deviceKind === null || deviceKind === DEVICES_KINDS.OTHER) {
          return devicesWithoutDoubles;
        }

        return devicesWithoutDoubles.filter((device) => device.kind === deviceKind);
      },

    // get clinician connected default device (microphone or speaker) by kind
    getClinicianConnectedDefaultDevice: (state) => (deviceKind) =>
      state.clinicianDefaultDevices.find((device) => device.device_kind === deviceKind)
        ?.device_data,
  },

  actions: {
    setDeviceTypesUseCases(deviceTypesUseCases) {
      this.deviceTypesUseCases = deviceTypesUseCases;
    },

    // change device slot state by specified slot ID and action (set device to slot or remove device from slot)
    manageClinicianDeviceSlot(slotId, action, deviceData = null) {
      let storedClinicianDevice;

      switch (action) {
        case DEVICE_SLOT_ACTIONS.ADD_DEVICE:
          storedClinicianDevice = {
            device_data: {
              deviceId: deviceData.deviceId,
              groupId: deviceData.groupId,
              kind: deviceData.kind,
              label: deviceData.label,
            },
          };
          break;
        case DEVICE_SLOT_ACTIONS.DELETE_DEVICE:
        default:
          storedClinicianDevice = null;
          break;
      }

      // find slot with specified ID in use cases hierarchy and set device data
      this.deviceTypesUseCases.forEach((useCase, useCaseIndex) => {
        useCase.device_type_usage_priorities.forEach((useagePriority, useagePriorityIndex) => {
          useagePriority.device_type_use_case_slots.forEach((slot, slotIndex) => {
            if (slot.id === slotId) {
              // very-very long "path" to slot...
              this.deviceTypesUseCases[useCaseIndex].device_type_usage_priorities[
                useagePriorityIndex
              ].device_type_use_case_slots[slotIndex].stored_clinician_device =
                storedClinicianDevice;
            }
          });
        });
      });
    },

    // Set clinician default devices (microphone and speaker),
    // stored on back-end side, to Pinia
    setDefaultClinicianDevices(defaultClinicianDevices) {
      this.clinicianDefaultDevices = defaultClinicianDevices;
    },

    // set or chande clinician default device (microphone and speaker)
    manageDefaultClinicianDevices(deviceKind, device) {
      const index = this.clinicianDefaultDevices.findIndex((obj) => obj.device_kind === deviceKind);

      // Pay atention! In JS "index === -1" means that "array element not found"

      if (index !== -1) {
        this.clinicianDefaultDevices[index] = { device_kind: deviceKind, device_data: device };
      } else {
        this.clinicianDefaultDevices.push({ device_kind: deviceKind, device_data: device });
      }
    },
  },
});

export default useDeviceAndSessionSetupStore;
